import { authCheck, plain, secured } from '@/app/config/axios';

const resource = 'auth';

export default {
    user: () =>
        authCheck.get(`${resource}/user`, {
            headers: {
                'Cache-Control': 'no-cache',
            },
        }),
    updateUser: (data: any) => secured.put(`${resource}/user`, data),
    logout: () => secured.post(`${resource}/logout`),
    keycloakLogin: () => plain.post(`${resource}/keycloak-login`),
};
